import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import AuthPage from "./pages/AuthPage";
import Panel from "./pages/Panel";
import Graficos from "./pages/Graficos";
import Anadir from "./pages/Anadir";
import Recurrentes from "./pages/Recurrentes";
import Legal from "./pages/Legal";
import { Historial, Cuentas, ProPage, Ajustes, SuccessPage } from "./pages/OtherPages";
import Pendientes from "./pages/Pendientes";
import Presupuestos from "./pages/Presupuestos";
import CuentaCompartida from "./pages/CuentaCompartida";
import Huchas from "./pages/Huchas";
import Inversiones from "./pages/Inversiones";
import Contactos from "./pages/Contactos";
import { useNotifications } from "./contexts/useNotifications";
import InstallPrompt from "./components/InstallPrompt";
import OnboardingTour from "./components/OnboardingTour";
import "./index.css";

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  // IMPORTANTE: mientras AuthContext todavía está comprobando si hay una
  // sesión válida (loading=true), "user" es null por defecto en el primer
  // render — eso NO significa "no hay sesión", solo que aún no se sabe.
  // Sin esta comprobación, cualquier recarga completa de página (como la
  // que hace el navegador al volver de una redirección externa, p. ej.
  // tras completar un pago en Stripe Checkout y regresar a /success)
  // redirige al login de forma falsa antes de que onAuthStateChanged
  // tenga ocasión de confirmar la sesión real — el usuario "es expulsado"
  // de la app aunque su sesión siga siendo válida.
  if (loading) return null; // o un spinner/pantalla de carga si se prefiere
  if (!user) return <Navigate to="/auth?tab=login" replace />;
  if (!user.emailVerified) return <Navigate to="/auth?tab=login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  useNotifications();

  return (
    <Routes>
      <Route path="/" element={user && user.emailVerified ? <Navigate to="/panel" replace /> : <Navigate to="/auth?tab=login" replace />} />
      <Route path="/auth"          element={user && user.emailVerified ? <Navigate to="/panel" replace /> : <AuthPage />} />
      <Route path="/panel"         element={<PrivateRoute><Layout><Panel /></Layout></PrivateRoute>} />
      <Route path="/graficos"      element={<PrivateRoute><Layout><Graficos /></Layout></PrivateRoute>} />
      <Route path="/cuentas"       element={<PrivateRoute><Layout><Cuentas /></Layout></PrivateRoute>} />
      <Route path="/anadir"        element={<PrivateRoute><Layout><Anadir /></Layout></PrivateRoute>} />
      <Route path="/recurrentes"   element={<PrivateRoute><Layout><Recurrentes /></Layout></PrivateRoute>} />
      <Route path="/historial"     element={<PrivateRoute><Layout><Historial /></Layout></PrivateRoute>} />
      <Route path="/pendientes"    element={<PrivateRoute><Layout><Pendientes /></Layout></PrivateRoute>} />
      <Route path="/presupuestos"  element={<PrivateRoute><Layout><Presupuestos /></Layout></PrivateRoute>} />
      <Route path="/cuenta-compartida" element={<PrivateRoute><Layout><CuentaCompartida /></Layout></PrivateRoute>} />
      <Route path="/huchas"        element={<PrivateRoute><Layout><Huchas /></Layout></PrivateRoute>} />
      <Route path="/inversiones"   element={<PrivateRoute><Layout><Inversiones /></Layout></PrivateRoute>} />
      <Route path="/contactos"     element={<PrivateRoute><Layout><Contactos /></Layout></PrivateRoute>} />
      <Route path="/ajustes"       element={<PrivateRoute><Layout><Ajustes /></Layout></PrivateRoute>} />
      <Route path="/pro"           element={<PrivateRoute><Layout><ProPage /></Layout></PrivateRoute>} />
      <Route path="/success"       element={<PrivateRoute><Layout><SuccessPage /></Layout></PrivateRoute>} />
      <Route path="/legal"         element={<Legal />} />
      <Route path="*"              element={<Navigate to="/auth?tab=login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <InstallPrompt />
        <OnboardingTour />
      </BrowserRouter>
    </AuthProvider>
  );
}
